/* eslint-disable react/destructuring-assignment */
import { Tooltip, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import React from "react";

const CodeView = props => {
  const script = `
  <script>
    (function() {
      var script = document.createElement('script');
      script.src = "${process.env.GATSBY_SCRIPT_URL?.trim()}?t=" + new Date().getTime();
      script.setAttribute('engagedAi-Uid', "${props.widgetId}");
      document.head.appendChild(script);
    })();
</script>`;
  return (
    <div className="p-2 gap-2 w-full flex-row-centered items-center">
      <code className="p-2 inline-block w-full overflow-x-auto bg-slate-100 rounded">{script}</code>
      <Tooltip title="Copy to clipboard">
        <CopyOutlined
          className="cursor-pointer"
          onClick={() => {
            navigator.clipboard
              .writeText(script)
              .then(() => {
                props && props.onCopy && props.onCopy();
                message.success("Script copied successfully");
              })
              .catch(err => message.error(err.message));
          }}
        />
      </Tooltip>
    </div>
  );
};

export default CodeView;
